import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { useInAppBrowser } from "@/lib/hooks/useInAppBrowser.hook";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Shown on auth pages when the user is inside a social-app webview
 * (LinkedIn, Instagram, …) where Google/Apple popup login cannot work.
 */
export function InAppBrowserBanner() {
	const { t } = useTranslation("common");
	const { isInAppBrowser, appName, isIOS, isAndroid, openInExternalBrowser } =
		useInAppBrowser();

	if (!isInAppBrowser) {
		return null;
	}

	const description = appName
		? t("inAppBrowser.description", { app: appName })
		: t("inAppBrowser.descriptionGeneric");

	const hint = isIOS
		? t("inAppBrowser.iosHint")
		: isAndroid
			? t("inAppBrowser.androidHint")
			: null;

	return (
		<Alert className="border-amber-500/30 bg-amber-500/5 text-left">
			<ExternalLink className="h-4 w-4 text-amber-600 dark:text-amber-400" />
			<AlertTitle className="line-clamp-none text-foreground">
				{t("inAppBrowser.title")}
			</AlertTitle>
			<AlertDescription className="mt-1 gap-2">
				<p>{description}</p>
				<Button
					type="button"
					size="lg"
					className="mt-1 min-h-11 w-full sm:w-auto"
					onClick={() => openInExternalBrowser(window.location.href, "banner")}
				>
					<ExternalLink className="h-4 w-4" />
					{t("inAppBrowser.openInBrowser")}
				</Button>
				{hint ? <p className="text-xs">{hint}</p> : null}
			</AlertDescription>
		</Alert>
	);
}
